import { ca } from '@cian/analytics';

export function trackOpenClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Open',
    label: 'From_card_save',
  });
}
